<template>
  <GlobalWindow
    title="添加小说"
    :visible.sync="visible"
    :show="true"
    width="20%"
    @confirm="confirm"
    @closeDialog="close"
  >
    <el-form label-width="100px">
      <el-form-item label="小说名称：">
        <!-- <el-autocomplete
          v-model="form.lead"
          style="margin-right: 10px"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择渠道号名称"
          @select="handleSelect"
        /> -->
        <el-input v-model="form.name" placeholder="请输入小说名称" />
      </el-form-item>
      <el-form-item label="主角：">
        <el-input v-model="form.lead" />
      </el-form-item>
      <el-form-item label="投放平台：">
        <el-select v-model="form.platform_id" placeholder="请选择" filterable>
          <el-option
            v-for="item in platformData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow'
import { novelScreening } from '@/api/report/novalList.js'
export default {
  name: 'AddNoval',
  components: { GlobalWindow },
  props: {
    // 获取父组件筛选列表
    platformData: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      visible: false,
      // 收集表单数据
      form: {
        name: null,
        platform_id: null,
        lead: null
      },
      state: ''
    }
  },
  methods: {
    confirm() {
      if (!this.form.name === null || !this.form.platform_id) {
        this.$message({
          message: '除主角外其他各项都不能为空',
          type: 'error'
        })
        return
      }
      this.$emit('confirm', this.form)
      this.form = {}
      this.visible = false
    },
    close() {
      this.form = {}
      this.visible = false
    },
    open() {
      this.visible = true
    },
    async querySearchAsync(queryString, callback) {
      var list = [{}]
      const response = await novelScreening({
        keyword: this.state
      })
      for (const i of response.data.list) {
        i.value = i.lead // 想要展示的数据 // 将想要展示的数据作为value
      }
      list = response.data.list
      callback(list)
    },
    handleSelect(item) {
      console.log(item)
      this.form.lead = item.lead
      this.form.name = item.name
    }
  }
}
</script>

<style scoped>

</style>
